import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeframeUsageComponent } from './component/timeframe-usage.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@sdbn/appclient';
import { SharedModule } from 'src/app/shared/shared.module';
import { StructureNodeSelectionModule } from 'src/tmc-yard/components/structure-node-selection/structure-node-selection.module';
import { CommonTranslationModule } from '@sdbn/common';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    StructureNodeSelectionModule,
    CommonTranslationModule
  ],
  declarations: [TimeframeUsageComponent]
})
export class TimeframeUsageModule { }
